import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Categories from "@/pages/Categories";
import Suppliers from "@/pages/Suppliers";
import Customers from "@/pages/Customers";
import Commesse from "@/pages/Commesse";
import Movements from "@/pages/Movements";
import Inventory from "@/pages/Inventory";
import DDT from "@/pages/DDT";
import Warehouses from "@/pages/Warehouses";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import Backup from "@/pages/Backup";
import Settings from "@/pages/Settings";
import PurchaseRequests from "@/pages/PurchaseRequests";
import PurchasePrices from "@/pages/PurchasePrices";
import PurchaseSummary from "@/pages/PurchaseSummary";
import InventoryCounts from "@/pages/InventoryCounts";
import TransferOrders from "@/pages/TransferOrders";
import Layout from "@/components/Layout";
import ForcePasswordChange from "@/components/ForcePasswordChange";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-neutral-500">Caricamento...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-neutral-500">Caricamento...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
          <Route path="/categories" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
          <Route path="/suppliers" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
          <Route path="/commesse" element={<ProtectedRoute><Commesse /></ProtectedRoute>} />
          <Route path="/movements" element={<ProtectedRoute><Movements /></ProtectedRoute>} />
          <Route path="/inventory" element={<ProtectedRoute><Inventory /></ProtectedRoute>} />
          <Route path="/ddt" element={<ProtectedRoute><DDT /></ProtectedRoute>} />
          <Route path="/warehouses" element={<ProtectedRoute><Warehouses /></ProtectedRoute>} />
          <Route path="/users" element={<AdminRoute><Users /></AdminRoute>} />
          <Route path="/audit" element={<AdminRoute><AuditLog /></AdminRoute>} />
          <Route path="/backup" element={<Navigate to="/settings" replace />} />
          <Route path="/settings" element={<AdminRoute><Settings /></AdminRoute>} />
          <Route path="/purchase-requests" element={<ProtectedRoute><PurchaseRequests /></ProtectedRoute>} />
          <Route path="/purchase-prices" element={<ProtectedRoute><PurchasePrices /></ProtectedRoute>} />
          <Route path="/purchase-summary" element={<ProtectedRoute><PurchaseSummary /></ProtectedRoute>} />
          <Route path="/inventory-counts" element={<ProtectedRoute><InventoryCounts /></ProtectedRoute>} />
          <Route path="/transfer-orders" element={<ProtectedRoute><TransferOrders /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <ForcePasswordChange />
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
